//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {},
  name: 'search-list-wrap',
  data() {
    return {
      searText: '',
      hotTagList: [
        { name: '案例分析', url: 'javascript:;' },
        { name: '调解技巧', url: 'javascript:;' },
        { name: '调解身心健康培训', url: 'javascript:;' },
        { name: '案例分析', url: 'javascript:;' },
        { name: '调解身心健康培训', url: 'javascript:;' },
        { name: '案例分析', url: 'javascript:;' },
        { name: '调解身心健康培训', url: 'javascript:;' },
        { name: '案例分析', url: 'javascript:;' }
      ],
      historicalList: [
        { name: '人民调解课程', url: 'javascript:;' },
        { name: '调解技巧', url: 'javascript:;' },
        { name: '案例分析', url: 'javascript:;' },
        { name: '调解身心健康培训', url: 'javascript:;' }
      ],
      queryList: [
        { name: '人民调解课程', url: 'javascript:;', htmlName: '' },
        { name: '调解技巧', url: 'javascript:;', htmlName: '' },
        { name: '案例调解分析', url: 'javascript:;', htmlName: '' },
        { name: '调解身心健康培训', url: 'javascript:;', htmlName: '' }
      ],
      hisHotSwite: true
    };
  },
  methods: {
    ...mapActions(['settabbar']),
    clearSearch() {
      this.searText = '';
    },
    removeHis(idx) {
      let arr = this.historicalList;
      arr.splice(idx, 1);
      this.historicalList = arr;
    },
    clearHis() {
      this.historicalList = [];
    },
    inputFocus() {}
  },
  watch: {
    searText(newVal) {
      let newArr = this.queryList;
      let regex = /\s/g;
      let textR = newVal.replace(regex, ''); // 清除空格
      let rex = new RegExp('' + textR + '', 'g'); // 正则
      for (let i = 0; i < this.queryList.length; i++) {
        let inerrName = this.queryList[i].name;
        inerrName = inerrName.replace(
          rex,
          '<b style="color: #32b16c">' + textR + '</b>'
        );
        this.queryList[i].htmlName = inerrName;
      }
      if (textR) {
        this.hisHotSwite = false;
      } else {
        this.hisHotSwite = true;
      }
    }
  },
  computed: {
    ...mapGetters([])
  },
  created() {
    //this.settabbar(false);
  },
  mounted() {
    let elem = document.querySelector('#vux_view_box_body');
    setTimeout(() => {
      elem.style.paddingBottom = '0';
    }, 10);
  }
};
